import { render, staticRenderFns } from "./ktooltip.vue?vue&type=template&id=bbf4387c"
import script from "./ktooltip.vue?vue&type=script&lang=js"
export * from "./ktooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports